import { Icon } from './Icon.jsx';

export function AlertBanner({ text, onRetry }) {
  return (
    <div className="alert-banner">
      <span className="msg">
        <Icon.alert /> {text}
      </span>
      <button onClick={onRetry}>Retry</button>
    </div>
  );
}
